export default __webpack_public_path__ + "bad23ddeda5c24614e44d2b0c77b233c.png";